module.exports = __webpack_public_path__ + "img/hiw-3.7149c770.svg";